<script lang="ts">
  import { onMount } from 'svelte';
  import { register } from 'swiper/element/bundle';
  import { getAppConfig } from '../../common/config/app-config';
  import '../../common/i18n/i18n';
  import { isMobileUIExperience, unxUpdateTopAndBottomSeoContent } from '../../common/util';
  import CategorySeoContent from '../common/components/CategorySeoContent.svelte';
  import ExtraSnackBar from '../common/components/ExtraSnackBar.svelte';
  import LazyComponentLoader from '../common/lazy-components/driver/LazyComponentLoader.svelte';
  import { BRAND_CONTENT_SLOT_ORDER } from '../common/lazy-components/driver/common-mapper';
  import { getCMSComponentsFromHybrisAsync } from '../common/services/hybris';
  import AppFooterPage from '../footer/AppFooterPage.svelte';
  import { getCartLoginDetails } from '../header/services/header-service';
  import { isCategoryStaticBottomContent } from '../product-listing-search/store/plp-data-store';

  let brandContentSlotInfo: string;
  let componentData;
  const { svelteModuleFooterEnabled } = getAppConfig();

  $: contentSlotToComponentUidsArray =
    brandContentSlotInfo &&
    (brandContentSlotInfo
      .substring(1, brandContentSlotInfo.length - 2)
      .split('], ')
      .map(s => s.replace(/=\[/g, '='))
      .map(s => s.split('='))
      .map(([a, b]) => [a, b])
      .filter(([slotName]) => BRAND_CONTENT_SLOT_ORDER.includes(slotName))
      .map(([slotName, compsString]) => [slotName, compsString.split(', ')])
      .sort(sorterBasedOnAnotherArray(BRAND_CONTENT_SLOT_ORDER)) as [string, string[]][]);

  $: slotNameToGroupedUidsArray =
    contentSlotToComponentUidsArray &&
    contentSlotToComponentUidsArray.length > 0 &&
    groupSlots(contentSlotToComponentUidsArray, {});

  $: componentUids =
    slotNameToGroupedUidsArray && slotNameToGroupedUidsArray.map(([, componentUids]) => componentUids).flat();
  $: if (componentUids && componentUids.length > 0) {
    getCMSComponentsFromHybrisAsync(componentUids, true).then(data => (componentData = data));
  }

  $: console.log(componentData);

  $: componentDataMap =
    componentData &&
    componentData.component &&
    componentData.component
      .map(c => {
        return { [c.uid]: c };
      })
      .reduce((prev, curr) => Object.assign(prev, curr), {});

  onMount(() => {
    register();
    getCartLoginDetails();
    brandContentSlotInfo = window['ACC'].config.contentSlotInfo;
    unxUpdateTopAndBottomSeoContent();
    // if(window['ACC'].extragtm !== undefined) {
    //   window['ACC'].extragtm.click.trackViewList('', ' brand_page', []);
    // }
  });

  function sorterBasedOnAnotherArray(refArray: string[]) {
    return (a, b) => refArray.indexOf(a[0]) - refArray.indexOf(b[0]);
  }

  function groupSlots(sortedSlots: [string, string[]][], slotGroups): [string, string[]][] {
    const output = [];
    const processedCombineIds = [];
    sortedSlots.forEach(sortedSlot => {
      const [slotname] = sortedSlot;
      if (slotname in slotGroups) {
        const combineId = slotGroups[slotname];
        if (processedCombineIds.indexOf(combineId) === -1) {
          // combine the slots
          const slotNamesWithCurrentCombineId = Object.keys(slotGroups).filter(x => slotGroups[x] === combineId);
          const combinedUids = sortedSlots
            .filter(x => slotNamesWithCurrentCombineId.indexOf(x[0]) > -1)
            .map(x => x[1])
            .flat();
          const combinedSlot = [slotname, combinedUids];
          output.push(combinedSlot);
          processedCombineIds.push(combineId);
        }
      } else {
        output.push(sortedSlot);
      }
    });
    return output;
  }
</script>

<section class="brand-page svelte-page">
  {#if slotNameToGroupedUidsArray?.length > 0 && componentDataMap}
    {#each slotNameToGroupedUidsArray as [slotName, componentUids]}
      <LazyComponentLoader {slotName} {componentUids} componentsData={componentUids.map(c => componentDataMap[c])} />
    {/each}
  {/if}
  {#if $isCategoryStaticBottomContent}
    <CategorySeoContent />
  {/if}
  <!-- <Snackbar /> -->
  <ExtraSnackBar />
</section>

{#if svelteModuleFooterEnabled && !isMobileUIExperience()}
  <AppFooterPage />
{/if}

<style lang="scss">
  @import '../common/styles/colors.new.scss';
  .svelte-page {
    background-color: $neutral-light-04;
    display: flex;
    flex-direction: column;
    padding-block: 0 20px;
  }
</style>
